// sport admin
import * as adminLearnPage from './sport/adminLearnPage/reducer'
import * as adminTicketPage from './sport/adminTicketPage/reducer'
import * as adminReportPage from './sport/adminReportPage/reducer'
import * as adminTariffPage from './sport/adminTariffPage/reducer'
import * as adminSchedulePage from './sport/adminSchedulePage/reducer'
import * as adminStatisticsPage from './sport/adminStatisticsPage/reducer'
import * as adminAreaConfigPage from './sport/adminAreaConfigPage/reducer'
import * as adminScheduleInputPage from './sport/adminScheduleInputPage/reducer'
import * as adminScheduleConfigPage from './sport/adminScheduleConfigPage/reducer'
import * as adminServiceConfigPage from './sport/adminServiceConfigPage/reducer'

import * as adminGroupsConfigPage from './sport/adminGroupsConfigPage/reducer'
import * as adminGroupsAddPage from './sport/adminGroupsAddPage/reducer'
import * as adminLearnCalculatePage from './sport/adminLearnCalculatePage/reducer'
import * as adminLearnTariffPage from './sport/adminLearnTariffPage/reducer'

// edu admin
import * as adminCatalogPage from './edu/adminCatalogPage/reducer'
import * as adminConfigSchoolsPage from './edu/adminConfigSchoolsPage/reducer'
import * as adminConfigSchoolStagesPage from './edu/adminConfigSchoolStagesPage/reducer'
import * as adminConfigDaysPage from './edu/adminConfigDaysPage/reducer'
import * as adminConfigAccessPage from './edu/adminConfigAccessPage/reducer'
import * as adminRegistryPage from './edu/adminRegistryPage/reducer'
import * as adminReportFoodPage from './edu/adminReportFoodPage/reducer'
import * as adminCancelFoodPage from './edu/adminCancelFoodPage/reducer'

// sport customer
import * as customerOrderPage from './sport/customerOrderPage/reducer'
import * as customerLearnPage from './sport/customerLearnPage/reducer'
import * as customerCancelPage from './sport/customerCancelPage/reducer'
import * as customerTicketPage from './sport/customerTicketPage/reducer'
import * as customerSchedulePage from './sport/customerSchedulePage/reducer'

// edu customer
import * as customerOrderFoodPage from './edu/customerOrderFoodPage/reducer'
import * as customerCancelFoodPage from './edu/customerCancelFoodPage/reducer'

// sport cashier
import * as cashierLearnPage from './sport/cashierLearnPage/reducer'
import * as cashierLearnSalePage from './sport/cashierLearnSalePage/reducer'
import * as cashierCancelPage from './sport/cashierCancelPage/reducer'
import * as cashierTicketPage from './sport/cashierTicketPage/reducer'
import * as cashierSchedulePage from './sport/cashierSchedulePage/reducer'

// edu cashier
import * as cashierConfigFoodPage from './edu/cashierConfigFoodPage/reducer'
import * as cashierControlFoodPage from './edu/cashierControlFoodPage/reducer'
import * as cashierRegistryFoodPage from './edu/cashierRegistryFoodPage/reducer'
import * as cashierCancelFoodPage from './edu/cashierCancelFoodPage/reducer'
import * as cashierSalesFoodPage from './edu/cashierSalesFoodPage/reducer'

// access
import * as layersNavigation from './layersNavigation/reducer'
import * as accessLevel from './accessLevel/reducer'


export default {
  // sport admin
  adminLearnPage,
  adminTicketPage,
  adminReportPage,
  adminTariffPage,
  adminSchedulePage,
  adminStatisticsPage,
  adminAreaConfigPage,
  adminScheduleInputPage,
  adminScheduleConfigPage,
  adminServiceConfigPage,

  adminGroupsConfigPage,
  adminGroupsAddPage,
  adminLearnCalculatePage,
  adminLearnTariffPage,

  // edu admin
  adminCatalogPage,
  adminConfigSchoolsPage,
  adminConfigSchoolStagesPage,
  adminConfigDaysPage,
  adminConfigAccessPage,
  adminRegistryPage,
  adminReportFoodPage,
  adminCancelFoodPage,

  // sport customer
  customerOrderPage,
  customerLearnPage,
  cashierLearnSalePage,
  customerCancelPage,
  customerTicketPage,
  customerSchedulePage,

  // edu customer
  customerOrderFoodPage,
  customerCancelFoodPage,
  cashierRegistryFoodPage,

  // sport cashier
  cashierLearnPage,
  cashierCancelPage,
  cashierTicketPage,
  cashierSchedulePage,

  // edu cashier
  cashierConfigFoodPage,
  cashierControlFoodPage,
  cashierCancelFoodPage,
  cashierSalesFoodPage,

  // access
  layersNavigation,
  accessLevel,
}
